module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.8-121.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.8.md
// module id = 538
// module chunks = 269